import {useState} from "react";
import axios from "axios";
import {baseURL} from "../utils/common";
export const LoginPage = () => {
    const [form, setForm] = useState({
        username: "",
        password: "",
    });
    const [error, setError] = useState(false);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        axios.post(`${baseURL}/users/login/admin/`, {...form}).then(
            res => {
                localStorage.setItem("authToken", res.data.token);
                window.location.reload();
            }
        ).catch(
            err => {
                setError(true);
            }
        )
    };
    return (
        <main className="login-page">
            <div className="login-card">
                <div className="login-header">
                    <h1>Luminopt | Дашборд</h1>
                    <p>Войдите в аккаунт, чтобы продолжить</p>
                    {error && <p style={{color:"crimson", width:"100%", textAlign:"center", paddingTop:12}}>Неверный логин или пароль</p>}
                </div>
                <form className="login-form" onSubmit={handleSubmit}>
                    <label>
                        <span style={{paddingLeft:8}}>Логин</span>
                        <input
                            type="text"
                            name="username"
                            value={form.username}
                            onChange={handleChange}
                            placeholder="Введите логин"
                            autoComplete="username"
                        />
                    </label>

                    <label>
                        <span style={{paddingLeft:8}}>Пароль</span>
                        <input
                            type="password"
                            name="password"
                            value={form.password}
                            onChange={handleChange}
                            placeholder="Введите пароль"
                            autoComplete="current-password"
                        />
                    </label>

                    <button type="submit">Войти</button>
                </form>
            </div>
        </main>
    );
}
